export { default as BulletinAttachmentsScreen } from "./BulletinAttachmentsScreen";
